import React, { Component } from 'react';
import NoPermission from '../imgs/nopermission.png'

export class Home extends Component {
    static displayName = Home.name;

    render() {
        return (
            <div style={{ textAlign: 'center' }}>
                <img alt={"Beisen"} src={NoPermission} />
                <p>无访问权限</p>
            </div>
        );
    }
}
